export const SANKU_ACCOUNT_ID = "adad3a40-d28f-4dd3-8570-7a213b6cc4c7";

export const allowedExtensions = [
  // PDF
  "pdf",

  // Word
  "doc",
  "docx",
  "docm",
  "dot",
  "dotx",
  "odt",
  "rtf",

  // Excel
  "xls",
  "xlsx",
  "xlsm",
  "xlsb",
  "xlt",
  "xltx",
  "ods",
  "csv",

  // PowerPoint
  "ppt",
  "pptx",
  "pptm",
  "odp",

  // Images
  "png",
  "jpg",
  "jpeg",
  "gif",
  "bmp",
  "webp",

  // Text
  "txt",

  // Zip
  "zip",
  "rar",
  "7z"
];

export const COMPETENCY_CONFIG = {
  communication: { label: 'Communication', class: 'chip-manager' },
  reliability: { label: 'Reliability', class: 'chip-peer' },
  judgement: { label: 'Judgement', class: 'chip-skip' },
  judgment: { label: 'Judgement', class: 'chip-skip' },
  coaching: { label: 'Coaching', class: 'chip-report' },
  ownership: { label: 'Ownership', class: 'chip-self' },
};

export const REVIEW_PERIOD = {
  ANNUAL: 5,
  HALF_YEARLY: 4,
  QUARTERLY: 3,
  BIMONTHLY: 2,
  MONTHLY: 1,
};

export const REVIEW_PERIOD_LABELS = {
  [REVIEW_PERIOD.MONTHLY]: "Monthly",
  [REVIEW_PERIOD.BIMONTHLY]: "Bi-Monthly",
  [REVIEW_PERIOD.QUARTERLY]: "Quarterly",
  [REVIEW_PERIOD.HALF_YEARLY]: "Half-Yearly",
  [REVIEW_PERIOD.ANNUAL]: "Annual",
};

export const REVIEW_PERIOD_FREQUENCY = {
  [REVIEW_PERIOD.MONTHLY]: [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ],

  [REVIEW_PERIOD.BIMONTHLY]: [
    { value: 1, label: "Jan - Feb" },
    { value: 2, label: "Mar - Apr" },
    { value: 3, label: "May - Jun" },
    { value: 4, label: "Jul - Aug" },
    { value: 5, label: "Sep - Oct" },
    { value: 6, label: "Nov - Dec" },
  ],

  [REVIEW_PERIOD.QUARTERLY]: [
    { value: 1, label: "Jan - Mar" },
    { value: 2, label: "Apr - Jun" },
    { value: 3, label: "Jul - Sep" },
    { value: 4, label: "Oct - Dec" },
  ],

  [REVIEW_PERIOD.HALF_YEARLY]: [
    { value: 1, label: "January - June" },
    { value: 2, label: "July - December" },
  ],

  [REVIEW_PERIOD.ANNUAL]: [
    { value: 1, label: "Full Year" },
  ],
};



export const PERIOD_MONTHS = {
  [REVIEW_PERIOD.MONTHLY]: [
    [1],
    [2],
    [3],
    [4],
    [5],
    [6],
    [7],
    [8],
    [9],
    [10],
    [11],
    [12]
  ],

  [REVIEW_PERIOD.BIMONTHLY]: [
    [1, 2],
    [3, 4],
    [5, 6],
    [7, 8],
    [9, 10],
    [11, 12],
  ],

  [REVIEW_PERIOD.QUARTERLY]: [
    [1, 2, 3],
    [4, 5, 6],
    [7, 8, 9],
    [10, 11, 12],
  ],

  [REVIEW_PERIOD.HALF_YEARLY]: [
    [1, 2, 3, 4, 5, 6],
    [7, 8, 9, 10, 11, 12],
  ],

  [REVIEW_PERIOD.ANNUAL]: [
    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  ],
};

export const goalsMetricConfig = {
  0: { label: "Not Started", value: 0, color: "#A1A5AD" },
  1: { label: "On Hold", value: 0, color: "#F2A724" },
  2: { label: "Not Completed", value: 0, color: "#E5453F" },
  3: { label: "In Progress", value: 50, color: "#2680EB" },
  4: { label: "Completed", value: 100, color: "#0f9960" },
  "not_started": { label: "Not Started", value: 0, color: "#A1A5AD" },
  "on_hold": { label: "On Hold", value: 0, color: "#F2A724" },
  "not_completed": { label: "Not Completed", value: 0, color: "#E5453F" },
  "in_progress": { label: "In Progress", value: 50, color: "#2680EB" },
  "completed": { label: "Completed", value: 100, color: "#0f9960" }
}